export const LastLoginMethodExperimentKey = 'KRK-957';
export const lastLoginMethod = {
    [LastLoginMethodExperimentKey]: {
        experimentId: '4519453581377536',
        variantsIds: {
            A: '6178476135284736', // Original
            B: '6746586223476736', // Variation #1
        },
    },
};
//# sourceMappingURL=lastLoginMethod.js.map